export default [
    {
        path: "/lrc-in/users",
        component: () => import("@/App/RP/LRC/Components/List.vue"),
        name: "lrc.user",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/lrc-in/user/create",
        component: () => import("@/App/RP/LRC/Components/Create.vue"),
        name: "lrc.user.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/lrc-in/user/:id",
        component: () => import("@/App/RP/LRC/Components/Show.vue"),
        name: "lrc.user.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lrc-in/user/:id/edit",
        component: () => import("@/App/RP/LRC/Components/Edit.vue"),
        name: "lrc.user.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
